/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { BackToTop, getTelemetryObject, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IBackTopFooterProps } from './back-top-footer.props.autogenerated';

/**
 *
 * BackTopFooter component.
 * @extends {React.PureComponent<IBackTopFooterProps<{}>>}
 */
class BackTopFooter extends React.PureComponent<IBackTopFooterProps<{}>> {
    private readonly editProps: Msdyn365.ITextEditProps = {
        requestContext: this.props.context.request,
        onEdit: (event: Msdyn365.ContentEditableEvent) => this.props.config.backtoTopText = event.target.value
    };

    private readonly telemetryContent?: ITelemetryContent;

    constructor(props: IBackTopFooterProps<{}>) {
        super(props);
        this.telemetryContent = getTelemetryObject(this.props.context.request.telemetryPageName!, this.props.friendlyName, this.props.telemetry);
    }

    public render(): JSX.Element | null {
        if (!this.props.config.destination) {
            this.props.telemetry.error('BackToTop.destination has not been provided, module wont render.');
            return null;
        }

        return (
            <BackToTop
                href={this.props.config.destination}
                title={this.props.config.title}
                aria-label={this.props.config.ariaLabel}
                className='ms-back-to-top'
                editProps={this.editProps}
                text={this.props.config.backtoTopText}
                telemetryContent={this.telemetryContent}
            />
        );
    }
}

export default BackTopFooter;
